import React, { useState } from 'react'
import Swal from 'sweetalert2'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { GrDomain } from 'react-icons/gr'
import { MdEditNote } from 'react-icons/md'

function CertificateVerify() {
  const [formData, setFormData] = useState({
    rollNumber: '',
    fullName: '',
    email: '',
    mobileNo: '',
    domain: '',
    otherDomain: '',
    acceptTerms: false,
  })

  const [nameError, setNameError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [domainError, setDomainError] = useState('')
  const [rollNumberError, setRollNumberError] = useState('')

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target

    if (name === 'fullName') {
      setNameError(
        !value || !/^[A-Za-z\s]+$/.test(value) ? 'Invalid name format.' : ''
      )
    }
    if (name === 'email') {
      setEmailError(
        !value || !/\S+@\S+\.\S+/.test(value) ? 'Invalid email format' : ''
      )
    }
    if (name === 'mobileNo') {
      setPhoneError(
        !value || !/^\d{10}$/.test(value) ? 'Length should be 10 digits' : ''
      )
    }
    if (name === 'domain') {
      setDomainError(!value ? 'Please select a domain.' : '')
    }
    if (name === 'rollNumber') {
      setRollNumberError(!value ? 'Roll number is required' : '')
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (!formData.domain) {
      setDomainError('Please select a domain.')
      return
    }
    if (!formData.rollNumber || rollNumberError) {
      setRollNumberError('Please enter a valid roll number.')
      return
    }

    try {
      const response = await fetch('https://formspree.io/f/xwpkolva', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          domain: formData.domain === 'Other' ? formData.otherDomain : formData.domain,
        }),
      })

      if (response.ok) {
        Swal.fire({
          title: 'Form Submitted!',
          text:
            'Our team will review your submission and get back to you within 24 hours.',
          icon: 'success',
        })
        setFormData({
          fullName: '',
          email: '',
          mobileNo: '',
          domain: '',
          otherDomain: '',
          rollNumber: '',
          acceptTerms: false,
        })
      } else {
        throw new Error('Form submission failed')
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  return (
    <div>
      <style>
        {`
        .certificateverify-comp-label-text{
        font-size:14px;
        }
        `}
      </style>
      <div className="container">
        <div className="row mb-3 mt-4">
          <div className="col-md-3"></div>
          <div className="mt-5 py-3 px-3 pt-5 col-md-6">
            <div className="px-4 pt-2 pb-3 shadow rounded border">
              <form onSubmit={handleSubmit}>
                <div className="text-center">
                  <span className="contact_form_main border-bottom pb-1">
                    Fill The Form
                  </span>
                </div>
                {/* Roll Number */}
                <div className="form-group mt-3">
                  <label htmlFor="rollNumber">
                    <MdEditNote size="20px" color="#565add" /> Roll Number
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="text"
                    id="rollNumber"
                    name="rollNumber"
                    placeholder="Your answer"
                    value={formData.rollNumber}
                    onChange={handleInputChange}
                    required
                  />
                  {rollNumberError && (
                    <div className="text-danger">{rollNumberError}</div>
                  )}
                </div>

                {/* Full Name */}
                <div className="form-group mt-3">
                  <label htmlFor="fullName">
                    <SlUser size="20px" color="#565add" /> Full Name
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="text"
                    id="fullName"
                    name="fullName"
                    placeholder="Your answer"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  {nameError && <div className="text-danger">{nameError}</div>}
                </div>

                {/* Email */}
                <div className="form-group mt-3">
                  <label htmlFor="email">
                    <MdOutlineMailOutline size="20px" color="#565add" /> Email
                    Address
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your answer"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  {emailError && <div className="text-danger">{emailError}</div>}
                </div>

                {/* Phone Number */}
                <div className="form-group mt-3">
                  <label htmlFor="mobileNo">
                    <HiOutlinePhone size="20px" color="#565add" /> Phone Number
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="tel"
                    id="mobileNo"
                    name="mobileNo"
                    placeholder="Your answer"
                    value={formData.mobileNo}
                    onChange={handleInputChange}
                    required
                  />
                  {phoneError && <div className="text-danger">{phoneError}</div>}
                </div>

                {/* Domain */}
                <div className="form-group mt-3">
                  <label htmlFor="domain">
                    <GrDomain size="20px" color="#565add" /> Choose Domain
                  </label>
                  <select
                    className="form-control shadow-sm mt-2"
                    id="domain"
                    name="domain"
                    value={formData.domain}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select a Domain...</option>
                    <option value="Machine Learning">Machine Learning (Supervised)</option>
                    <option value="Artificial Intelligence">Artificial Intelligence (ChatBot, NLP)</option>
                    <option value="Web Development">Web Development</option>
                    <option value="Data Science">Data Science</option>
                    <option value="Cyber Security">Cyber Security</option>
                    <option value="Cloud Computing">Cloud Computing</option>
                    <option value="Android App Development">Android App Development</option>
                    <option value="Robotics">Robotics</option>
                    <option value="Autocad">Autocad</option>
                    <option value="Human Resources">Human Resources</option>
                    <option value="Finance">Finance</option>
                    <option value="Business Analytics">Business Analytics</option>
                    <option value="Java">Java</option>
                    <option value="Python">Python</option>
                    <option value="Digital Marketing">Digital Marketing & Marketing</option>
                    <option value="Full Stack Web Development">Full Stack Web Development</option>
                    <option value="Mern Stack">Mern Stack</option>
                    <option value="C, C++ With DSA">C, C++ With DSA</option>
                    <option value="Other">Other</option>
                  </select>
                  {domainError && <div className="text-danger">{domainError}</div>}
                </div>

                {/* Other Domain Input */}
                {formData.domain === 'Other' && (
                  <div className="form-group mt-3">
                    <label htmlFor="otherDomain">Specify Domain</label>
                    <input
                      type="text"
                      id="otherDomain"
                      name="otherDomain"
                      className="form-control shadow-sm mt-2"
                      placeholder="Your answer"
                      value={formData.otherDomain}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                )}

                {/* Checkbox */}
                <div className="form-group mt-3">
                  <input
                    type="checkbox"
                    id="acceptTerms"
                    name="acceptTerms"
                    checked={formData.acceptTerms}
                    onChange={handleInputChange}
                    required
                  />
                  <label htmlFor="acceptTerms" className="ms-1 certificateverify-comp-label-text">
                    Yes, I confirm that the details I have filled are correct.
                  </label>
                </div>

                {/* Submit Button */}
                <div className="d-flex justify-content-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary px-5 py-2"
                    disabled={!formData.acceptTerms}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
    </div>
  )
}

export default CertificateVerify
